import React from 'react';
import { BaseConfig } from '../BaseConfig';
import { UIProperties } from '../UIProperties';
import './ReturnToMainMenuUI.css'

const ReturnToMainMenuUI = (props: UIProperties<ReturnToMainMenuUIConfig>) => {
	return (
		<div className="in-game-ui-container ui-top-most-container">
			<div>
			</div>
			
		</div>
	);

};

export interface ReturnToMainMenuUIConfig extends BaseConfig {
	text: string;
	onYesClicked: () => void;
	onNoClicked: () => void;
}

export default ReturnToMainMenuUI;